var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { toPromise } from "src/shared/api/promise";
import ClientPropertyEndpoints from "src/shared/api/property/ClientPropertyEndpoints";
import _ from "underscore";
import { reactive } from "vue";
import Property from "./model/Property";
export const useClientPropertyStore = defineStore("clientPropertyStore", () => {
    const state = reactive({
        client_properties: {},
    });
    const setProperties = (propertyResponses) => {
        _.each(propertyResponses, (response) => {
            const property = new Property(response);
            state.client_properties[property.name] = property;
        });
    };
    const fetchProperties = () => __awaiter(void 0, void 0, void 0, function* () {
        const propertyResponses = yield toPromise(ClientPropertyEndpoints.getProperties());
        setProperties(propertyResponses);
    });
    const saveProperty = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        const existingProperty = getProperty(payload.name);
        if (existingProperty) {
            yield toPromise(ClientPropertyEndpoints.updateProperty(payload));
        }
        else {
            try {
                yield toPromise(ClientPropertyEndpoints.createProperty(payload));
            }
            catch (e) {
                yield toPromise(ClientPropertyEndpoints.updateProperty(payload));
            }
        }
        yield fetchProperties();
    });
    const getProperty = (name) => {
        return state.client_properties[name];
    };
    const getProperties = () => {
        return _.values(state.client_properties);
    };
    return {
        state,
        fetchProperties,
        saveProperty,
        getProperty,
        getProperties,
    };
});
